import { ChevronLeft } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React from "react";
import { View } from "tamagui";
import { type CreateWizardState, CreateWizardStep } from "./CreateWizardState";

export const CreateWizardBack: React.FC<{ state: CreateWizardState }> =
  observer((props) => {
    if (props.state.activeStep === CreateWizardStep.CREATE_USER) {
      return null;
    }

    return (
      <View
        cursor="pointer"
        onPress={() => {
          history.back();
        }}
      >
        <ChevronLeft />
      </View>
    );
  });
